import instance from 'utils/apiCalls';
import { COMMON_URLS } from './commonUrls';
import { configSlice } from './commonSlice';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'redux/rootReducer';
import { Action } from '@reduxjs/toolkit';
import { HouseholdIncome } from '../../../types/interface';

export async function commonDownloadFile(file_name: string) {
  try {
    const response = await instance.post(
      COMMON_URLS.DOWNLOAD_FILE + `?filename=${file_name}`,
      {},
      {
        responseType: 'blob'
      }
    );
    return response;
  } catch (error) {
    console.log('Error downloading file:', error);
    throw error;
  }
}

const { actions } = configSlice;

export const getAllConfiguration =
  () =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    try {
      const response = await instance.get(COMMON_URLS.MASTER_CONFIG);
      dispatch(
        actions.setConfigurartionData(response.data.frontendConfigurations)
      );
    } catch (error) {
      throw error;
    }
  };

export const downApplicationPdf =
  (
    application_id: string,
    requestData: HouseholdIncome,
    params: { application_id: string; user_id: number }
  ) =>
  async () => {
    const response = await instance.post(
      COMMON_URLS.DOWNLOAD_APPLICATION_PDF.replace(
        ':application_id',
        application_id
      ),
      requestData,
      {
        params: params,
        responseType: 'blob'
      }
    );
    return response;
  };
